<template>
  <div class="books-details">
    <!-- 顶部大图片 -->
    <!-- <imgBigCards path="/layout/list/thematicActivities"></imgBigCards> -->
    <!--第一个大模块  -->
    <div class="top-detail">
      <!-- thematicCards组件 -->
      <thematicCards :info="mydata.articleInfo">
        <template #collect>
          <!-- 加入收藏 -->
          <div
            v-if="mydata.articleInfo.is_collect === 0"
            class="box-collect"
            style="cursor: pointer"
            @click="isCollect"
          >
            <el-icon><Star /></el-icon>
            <p>加入收藏</p>
          </div>
          <!-- 取消收藏 -->
          <div
            v-else
            @click="isCollect"
            class="box-collect"
            style="cursor: pointer"
          >
            <el-icon class="collectTrue"><Star /></el-icon>
            <p class="collectTrue">取消收藏</p>
          </div>
        </template>
      </thematicCards>
    </div>
    <!-- 内容部分 -->
    <div class="box-content">
      <!-- 活动详情 -->
      <div class="content-list">
        <el-tabs
          v-model="activeName"
          class="demo-tabs"
          @tab-click="handleClick"
        >
          <el-tab-pane label="活动详情" name="first">活动详情</el-tab-pane>
        </el-tabs>
      </div>
      <!-- 主体内容 -->
      <div class="content-main">
        <p class="tableA" v-html="mydata.articleInfo.content"></p>
      </div>
    </div>

    <!-- 按钮 -->
    <div class="box-button">
      <el-button type="primary" @click="studentButton" v-if="mydata.is_time"
        >我要投稿</el-button
      >
      <el-button type="info" disabled v-else>活动已结束</el-button>
    </div>
  </div>
</template>

<script setup>
import { ElMessage } from "element-plus";
// import { Calendar } from "@element-plus/icons-vue";
// import { View } from "@element-plus/icons-vue";
// import { Download } from "@element-plus/icons-vue";
// import { Menu } from "@element-plus/icons-vue";
// import { Lock } from "@element-plus/icons-vue";

import { useRouter, useRoute } from "vue-router";
import dayjs from "dayjs";

import { reactive, onActivated } from "vue";
import { Star } from "@element-plus/icons-vue";
import imgBigCards from "@/components/imgBigCards/index.vue";
import thematicCards from "@/components/thematicCards/index.vue";

import column from "@/components/column/index.vue";

import rowBookCards from "@/components/rowBookCards/index.vue";

// 引入接口
import { articleInfo } from "@/api/home/index.js";

// 引入加入收藏、取消收藏接口
import { addFavoritesList } from "@/api/personalCenter/myCollection/index.js";
// 引入详情页取消收藏接口
import { cancelCollect } from "@/api/addedServices/index.js";
function handleClick(tab, event) {}
const router = useRouter();
const route = useRoute();

const mydata = reactive({
  activeName: "first",

  articleId: null, // 文章id值
  articleInfo: {}, // 文章详情

  // 基础地址
  VUE_APP_BASE_HOST: process.env.VUE_APP_BASE_HOST,
  userInfo: JSON.parse(localStorage.getItem("userInfo")) ?? {}, //用户信息

    is_time: false,  //报名时间是否结束
});



//报名时间是否结束
function endTimeFn() {
  let nowTime = new Date().getTime(); //现在时间
  let endTime = mydata.articleInfo.end_time * 1000; //报名截止时间
  if ( endTime > nowTime ) {
    mydata.is_time = true; //可报名
  } else {
    mydata.is_time = false; //不可报名
  }
}



//初始化函数
function init() {
  // 获取到传递过来的参数（文章的id）
  mydata.articleId = route.query.id;
  // 调用接口获取文章详情
  articleInfo({ id: mydata.articleId }).then((res) => {
    // console.log(res);
    mydata.articleInfo = res.data; //该文章文章 对应 的详情
    
      endTimeFn();//报名时间是否结束
    
    // 设置title标题
    window.document.getElementsByTagName("title")[0].innerHTML =
      mydata.articleInfo.title;
  });
}

init();

onActivated(() => {
  init();
});

/**加入收藏/取消收藏的点击事件  0未收藏  1已收藏 */
function isCollect() {
  if (mydata.articleInfo.is_collect !== 0) {
    // 调用取消收藏接口
    cancelCollect(mydata.userInfo.jwt, {
      content_id: mydata.articleInfo.id,
      type: 4,
    }).then((res) => {
      ElMessage({
        message: res.msg,
        type: "success",
      });
      // 查询列表
      init();
    });
  } else {
    // 调用加入收藏接口  类型(1:试卷,2:图书,3:文章,4:活动,5:视频)
    addFavoritesList(mydata.userInfo.jwt, {
      content_id: mydata.articleInfo.id,
      type: 4,
    }).then((res) => {
      ElMessage({
        message: res.msg,
        type: "success",
      });
      // 查询列表
      init();
    });
  }
}

//学生加入活动按钮点击事件
// function studentButton() {
//   // 跳转地址到表单页面
//   router.push({
//     path: "/layout/list/thisEventRegistrationStudent",
//     query: { id: mydata.articleId },
//   });
// }

//学生加入活动按钮点击事件
function studentButton() {
  //如果登录了，就正常跳转；否则，弹窗提醒未登录，然后跳转到登录页面
  if (mydata.userInfo.jwt) {
    // 如果身份是学生，那么正常跳转；否则，弹窗提醒一下
    if (mydata.userInfo.user_role === 1) {
      // 跳转地址到表单页面
      router.push({
        path: "/layout/list/thisEventRegistrationStudent",
        query: { id: mydata.articleId },
      });
    } else {
      ElMessage({
        message: "此活动仅对学生开放，感谢支持",
        type: "error",
      });
    }
  } else {
    // 弹窗提醒未登录
    ElMessage({
      message: "当前用户未登录",
      type: "error",
    });
    // 跳转到登录页面
    router.push({
      path: "/login/nowLogin",
    });
  }
}

// studentButton();
</script>

<style scoped lang="scss">
.books-details {
  background-color: #f9f9f9;
  overflow: hidden;
  // border: 1px solid red;
  padding-bottom: 40px; //距离bottomBar的距离

  ////////顶部大图片
  // > .big-img {
  //   width: 100%;
  //   height: 200px;
  //   // border:1px solid rgb(68, 0, 255);
  //   margin: 0 auto;
  // }
  // :deep(.box-img) {
  //   height: 200px;
  // }
  // //el-carousel元素
  // :deep(.el-carousel__container) {
  //   width: 100%;
  //   height: 200px;
  //   // padding:30px;
  // }

  //////////第一个大模块/////////////////
  .top-detail {
    width: 100%;
    // height: 457px;
    background-color: #ffffff;
    overflow: hidden;
    // margin-top:16px;
    // border: 1px solid rgb(68, 0, 255);

    ////////thematicCards组件
    .big-box {
      width: 100%;
      // height: 333px;
      // box-shadow: none;
      padding: 0px;
      :deep(.box-research) {
        width: 100%;
        height: 100%;
        padding: 0px;
        // border: 1px solid blue;
        // position: relative;
        img {
          width: 100%;
          height: 201px;
          border-radius: 0px;
          // margin-right: 24px;
          cursor: default !important;
        }
        .box-title {
          width: 343px;
          // height: 254px;
          padding-bottom: 20px;
          margin: 0 auto;
          .title-p {
            width: 100%;
            min-height: 28px !important;
            // color:red;
            font-size: 18px;
            line-height: 28px;
            // color:red;
            cursor: default !important;
          }
        }
        .el-button.el-button--primary {
          display: none;
          // border:1px solid red;
        }
        .box-collect {
          margin-top: 30px;
          font-size: 16px;
          font-weight: 400;
          // color: #009de0;
          display: flex;
          align-items: center;
          // position:relative;
          // border:1px solid blue;
          .el-icon {
            font-size: 24px;
            font-weight: 400;
            margin-right: 4px;
          }
          .collectTrue {
            color: #009de0;
          }
        }

        .box-collect:hover {
          color: #009de0;
        }
      }
    }
  }

  //////内容部分
  .box-content {
    // width: 1200px;
    // border: 1px solid red;
    margin: 0 auto;
    margin-top: 21px;
    // margin-bottom:16px;
    .content-list {
      width: 100%;
      height: 56px;
      background-color: #ffffff;
      margin-bottom: 12px;
      border-radius: 8px;
      // height: 220px;
      // border: 1px solid red;
      :deep(.demo-tabs > .el-tabs__content) {
        padding: 32px;
        color: #6b778c;
        font-size: 32px;
        font-weight: 600;
      }
      //////每个的
      :deep(.el-tabs__item.is-top) {
        width: 100px;
        // color: red;
        // border: 1px solid rgb(255, 0, 98);
        text-align: center;
        padding: 0px;
        padding-bottom: 15px;
        // border-left:1px solid #CCCCCC;
        font-size: 16px;
        font-weight: 400;
        // color:#333333;
      }

      ///////整体宽度
      :deep(.el-tabs__nav.is-top) {
        // border: 1px solid blue;
        margin-top: 16px;
      }
    }
    //主体内容
    .content-main {
      width: 100%;
      // border: 1px solid red;
      border-radius: 8px;
      padding: 16px;
      background-color: #ffffff;
    }
  }

  //按钮部分
  .box-button {
    // width: 1200px;
    margin: 0 auto;
    // border:1px solid blue;
    display: flex;
    justify-content: center;
    margin-top: 20px;
    :deep(.el-button) {
      width: 170px;
      height: 46px;
      padding: 10px;
      border-radius: 30px;
      margin: 0 auto;
      // position: absolute;
      // right: 0px;
      // bottom: 0px;
      // border:1px solid red;
      > span {
        // color: #ffffff;
        font-size: 14px;
        font-weight: 400;
        line-height: 24px;
      }
    }
  }
}
:deep(.icon-box > p) {
  font-size: 14px !important;
  line-height: 22px !important;
}
:deep(.icon-box2) {
  > div {
    > p {
      font-size: 14px !important;
      line-height: 22px !important;
      width: 70px !important;
    }
  }

  > p {
    font-size: 14px !important;
    line-height: 22px !important;
    text-align: justify;
    -webkit-line-clamp: 3 !important;
    // color:red;
    margin-top: 0px !important;
  }
}

:deep(.box-research > .box-title .icon-box2 > div[data-v-579b725d] .el-icon) {
  margin-top: 4px;
}
</style>
